/**
 * LinkList
 */
import clsx from 'clsx';
import React from 'react';
import Tooltip from '../Tooltip';
/** Main description for this component. */
var LinkList = function (_a) {
    var heading = _a.heading, tooltipText = _a.tooltipText, tooltipLabel = _a.tooltipLabel, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, width = _a.width, className = _a.className, children = _a.children;
    var Heading = headingLevel;
    return (React.createElement("div", { className: clsx(className), "data-cid": "LinkList" },
        heading && (React.createElement(Heading, { className: "inline-block text-p font-semibold mb-4" }, heading)),
        tooltipText && tooltipLabel && (React.createElement(Tooltip, { label: tooltipLabel, description: tooltipText, className: "align-text-bottom" })),
        React.createElement("ul", { className: clsx(width === 100 && "column-count-full") }, children)));
};
export default LinkList;
